interface ConfirmModalProps {
  show: boolean;
  selectedName: string;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function ConfirmModal({ show, selectedName, onCancel, onConfirm }: ConfirmModalProps) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center" style={{ background: "rgba(0,0,0,0.4)" }}>
      <div className="bg-white rounded-t-3xl w-full p-6" style={{ maxWidth: 480 }}>
        <div className="w-10 h-1 rounded-full bg-gray-200 mx-auto mb-5" />
        <div className="text-lg font-bold text-gray-800 mb-2">替换线路？</div>
        <div className="text-sm text-gray-500 mb-6">将「{selectedName}」替换到AI套餐中。</div>
        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 py-3 rounded-full text-sm font-semibold cursor-pointer whitespace-nowrap"
            style={{ background: "#F3F4F6", color: "#6B7280" }}
          >
            取消
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 py-3 rounded-full text-sm font-semibold text-white cursor-pointer whitespace-nowrap"
            style={{ background: "#1E3A8A" }}
          >
            确认替换
          </button>
        </div>
      </div>
    </div>
  );
}
